// extracted by mini-css-extract-plugin
module.exports = {"bar":"FilesNavBar_bar__1PYjq","withoutBack":"FilesNavBar_withoutBack__Ry3R3","rightBtn":"FilesNavBar_rightBtn__2E7oy"};